import { render, staticRenderFns } from "./skuHeader.vue?vue&type=template&id=2d114162&"
import script from "./skuHeader.vue?vue&type=script&lang=js&"
export * from "./skuHeader.vue?vue&type=script&lang=js&"
import style0 from "./skuHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports